import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BsPerson, BsCameraVideo } from "../../../assets/icons/vander";
import { formatTimeEsCO, getDailyAssessmentLabel } from "../../../helpers";
import { useDailyAssessmentStore, useScheduleEventStore } from "../../hooks";
import { LoadingData, ErrorMessage } from "../../ui";
import { DailyAssessmentPagination } from "../navigation";

export const DailyAssessmentCard = () => {
  // Datos del hook ----------------------------------------//
  const navigate = useNavigate();

  const {
    // Props
    scheduleEvents,
    filters,

    // Methods
    getDailyAssessmentEvents,
  } = useDailyAssessmentStore();

  const {
    // Methods
    handleSetScheduleEvent,
  } = useScheduleEventStore();

  // States ------------------------------------------------//
  const [page, setPage] = useState(1);
  const CARDS_PER_PAGE = 4;
  
  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  const handleScheduleEventSelect = (scheduleEvent) => {
    handleSetScheduleEvent(scheduleEvent);
    navigate("/doctor/patient-profile");
  };

  // Lógica de paginación
  const totalPages = Math.ceil(scheduleEvents.data.length / CARDS_PER_PAGE);
  const startIndex = (page - 1) * CARDS_PER_PAGE;
  const endIndex = startIndex + CARDS_PER_PAGE;
  const paginatedData = scheduleEvents.data.slice(startIndex, endIndex);

  // Efectos -----------------------------------------------//
  useEffect(() => {
    if (scheduleEvents.data.length === 0 && scheduleEvents.message === null) {
      getDailyAssessmentEvents({
        filters,
      });
    }
  }, [scheduleEvents.data, getDailyAssessmentEvents]);

  return (
    <div className="card shadow-md">
      <div className="card-body">
        <h4>{getDailyAssessmentLabel(filters.date)}</h4>
        <div className="card border">
          <div className="card-body">
            {scheduleEvents.isLoading && (
              <LoadingData
                className={`${scheduleEvents.data.length > 0 ? "mb-4" : ""}`}
              />
            )}
            {scheduleEvents.message?.type === "error" && (
              <ErrorMessage>{scheduleEvents.message.text}</ErrorMessage>
            )}

            {paginatedData.map((scheduleEvent, index) => {
              const border =
                index === paginatedData.length - 1 ? "" : "border-bottom";
              const padding =
                index === 0
                  ? "pb-4"
                  : index === paginatedData.length - 1
                  ? "pt-4"
                  : "py-4";
              const { patientSurgery, notes } = scheduleEvent;
              const { firstName, lastName, ips } = patientSurgery.patient.user;
              const { title } = patientSurgery.procedure.procedure;
              const { track } = patientSurgery;

              return (
                <div key={scheduleEvent.id} className={`${border} ${padding}`}>
                  <div className="d-flex gap-4 align-items-center">
                    <div className="vstack gap-2">
                      <div className="d-flex flex-wrap align-items-center gap-2">
                        <h5 className="mb-0">
                          {formatTimeEsCO(scheduleEvent.start)}
                        </h5>
                        <span className="badge bg-light text-dark">
                          {track}
                        </span>
                      </div>
                      <div>
                        <strong>Paciente: </strong>
                        {firstName} {lastName}
                      </div>
                      <div>
                        <strong>Procedimiento: </strong>
                        {title}
                      </div>
                      <div>
                        <strong>Ips: </strong>
                        {ips.name}
                      </div>
                    </div>
                    <div className="flex-shrink-0">
                      <button
                        className="btn btn-icon btn-primary me-2"
                        onClick={() => handleScheduleEventSelect(scheduleEvent)}
                      >
                        <BsPerson className="icons" />
                      </button>
                      <a
                        className="btn btn-icon btn-primary"
                        href={notes}
                        target="_blank"
                      >
                        <BsCameraVideo className="icons" />
                      </a>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <DailyAssessmentPagination page={page} setPage={setPage} totalPages={totalPages} />
      </div>
    </div>
  );
};
